<template>
  <div class="conrainer">
        <BigScreenHead>
          <template v-slot:center >
              <div class="head-title">服 务 管 理 板 块</div>
          </template>
        </BigScreenHead>
        <main>
            <div class="top">
                <div class="chart">
                    <div class="chartitle">服务网点（个）</div>
                    <div class="chart1"></div>
                </div>
                <div class="chart">
                    <div class="chartitle">服务人员（人）</div>
                    <div class="chart2"></div>
                </div>
                <div class="chart">
                    <div class="chartitle">当前报修中（台）</div>
                    <div class="chart3"></div>
                </div>
                <div class="chart">
                    <div class="chartitle">总维修（台/次）</div>
                    <div class="chart4"></div>
                </div>
                <div class="linechart"></div>
                <div class="barchart"></div>
            </div>
            <div class="bottom">
                <div class="map"></div>
                <div class="bottom-right">
                    <div class="tabletop"></div>
                    <div class="tablebox">
                        <table>
                            <tr>
                                <td style="width:5%"></td>
                                <td>报修时间</td>
                                <td>报修人员</td>
                                <td>报修电话</td>
                                <td>出厂编号</td>
                                <td>客户名称</td>
                                <td>报修内容</td>
                                <td>网点名称</td>
                                <td style="width:10%">报修状态</td>
                            </tr>
                            <tr v-for="(item,i) in list" :key="item.id">
                                <td>{{i+1}}</td>
                                <td v-overflow>{{item.repairTime | timeFomart}}</td>
                                <td v-overflow>{{item.repairPerson}}</td>
                                <td v-overflow>{{item.repairPersonTel}}</td>
                                <td v-overflow>{{item.factorNo}}</td>
                                <td v-overflow>{{item.customerName}}</td>
                                <td v-overflow>{{item.repairContent}}</td>
                                <td v-overflow>{{item.nodeName}}</td>
                                <td v-overflow :style="{color:item.result==0?'#bf0000':'#40b337'}">{{item.id?(item.result==0?'未解决':'已解决'):''}}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="page">
                        <div @click="prev">上一页</div>
                        <div style="margin:0 2%;">第{{option.pageIndex}}页 共{{total}}条</div>
                        <div @click="next">下一页</div>
                    </div>
                </div>
            </div>
        </main>
  </div>
</template>

<script>
import { fuwuPie,fuwuLine,fuwuBar,fuwuMap } from '../assets/js/echarts'
export default {
    data(){
        return{
            info:{},
            option:{
                pageSize: 15,
                pageIndex: 1
            },
            list: [],
            total: 0,
        }
    },
    methods:{
        //格式化表格
        listFomart(option){
            if(option.length < 15){
                for(let i=option.length; i<15; i++){
                    option.push({})
                }
            }
        },
        //饼图信息
        getNodePieChartInfo(){
            this.$api.NodePieChartInfo().then(res=>{
                this.info = res.data.data;
                var tempData = this.info;
                var repairDate = []
                tempData.repairChartDate.map((item,i)=>{
                    repairDate[i] = item.slice(5,7)
                })
                fuwuPie({doc:'.chart1',type:1,data:[{ name:'自营',value:tempData.selfSupportNode },{ name:'加盟',value:tempData.joinNode }],text:tempData.nodeTotal})
                fuwuPie({doc:'.chart2',type:2,data:[{ name:'普通人员',value:tempData.generalPerson },{ name:'特种人员',value:tempData.specialPerson }],text:tempData.personTotal})
                fuwuPie({doc:'.chart3',type:3,data:[{ name:'塔机',value:tempData.towerRepair },{ name:'升降机',value:tempData.lifterRepair }],text:tempData.repairTotal})
                fuwuPie({doc:'.chart4',type:4,data:[{ name:'塔机',value:tempData.towerHisRepair },{ name:'升降机',value:tempData.lifterHisRepair }],text:tempData.hisRepairTotal})
                fuwuLine({doc:'.linechart',date:repairDate,data:tempData.repairChartValue});
                fuwuBar({doc:'.barchart',date:tempData.nodeRepairChartDate,data:tempData.nodeRepairChartValue});
            })
        },
        //地图信息
        getRepairMapInfo(){
            this.$api.RepairMapInfo().then(res=>{
                var nodeData = [];
                var repairData = [];
                var mapData = []
                res.data.data.nodeList.map(item=>{
                    nodeData.push({
                        type: 1,
                        name : item.name,
                        value: [item.gpsX,item.gpsY],
                        linker: item.linker,
                        linkerTel: item.linkerTel,
                        address: item.address
                    })
                })
                res.data.data.repairList.map(item=>{
                    repairData.push({
                        type: 2,
                        name : item.cuatomerName,
                        value: [item.gpsX,item.gpsY],
                        repairAddress: item.repairAddress,
                        repairPerson: item.repairPerson,
                        repairPersonTel: item.repairPersonTel,
                        repairTime: item.repairTime.replace(/T/,' '),
                        repairContent: item.repairContent
                    })
                })
                mapData = [...nodeData,...repairData]
                fuwuMap({doc:'.map',data:mapData});
            })
        },
        //表格
        getRepairLogInfo(option){
            this.$api.RepairLogInfo(option).then(res=>{
                this.list = res.data.data.data;
                this.total = res.data.data.total;
                this.listLength = this.list.length;
                this.listFomart(this.list);
            })
        },
        //上一页
        prev(){
            if (this.option.pageIndex <= 1) return;
            this.option.pageIndex --;
            this.getRepairLogInfo(this.option);
        },
        //下一页
        next(){
            if(this.listLength < this.option.pageSize) return;
            this.option.pageIndex ++;
            this.getRepairLogInfo(this.option);
        }
    },
    mounted(){
        this.getNodePieChartInfo();
        this.getRepairMapInfo();
        this.getRepairLogInfo(this.option);
    },
}
</script>

<style lang="scss" scoped>
.conrainer{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url('../assets/images/bigScreen_back.webp') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 0 1rem;
}
.head-title{
    font-size: 1.5625rem;
    font-weight: bold;
    letter-spacing: 5px;
}
main{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}
.top{
    height: 23%;
    display: flex;
    .chart{
        width: 12%;
        display: flex;
        flex-direction: column;
    }
    .chart1,.chart2,.chart3,.chart4,.chart5{
        flex: 1;
    }
    .chartitle{
        height: 18%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        font-weight: bold;
        letter-spacing: 1px;
    }
    .linechart{
        width: 25%;
    }
    .barchart{
        width: 25%;
        margin-left: 2%;
    }
}
.bottom{
    flex: 1;
    display: flex;
    .map{
        width: 42%;
    }
    .bottom-right{
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-left: 10px;
        .tabletop{
            height: 3%;
        }
        .tablebox{
            flex: 1;
        }
        table{
            height: 100%;
            width: 100%;
            flex: 1;
            table-layout: fixed;
            border-collapse: collapse;
            overflow: hidden;
            td{
                border: 1px solid #fff;
                text-align: center;
                font-size: 0.9375rem;
            }
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 6%;
            font-weight:bold;
            font-size: 0.9375rem;
            & div{ cursor: pointer;}
            & div:active{ color: #EDB941;}
        }
    }
}
</style>